<mat-form-field appearance="outline">
  <mat-label>Anställningsdatum, startdatum</mat-label>
  <input
    #input=ngModel
    matInput [matDatepicker]="startPicker"
    [(ngModel)]="model"
    placeholder="Startdatum"
    required
  >
  <mat-hint>ÅÅÅÅ-MM-DD</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="startPicker"/>
  <mat-datepicker #startPicker/>
</mat-form-field>